// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"607":"761e6f66","787":"d6392bef","857":"74d52700"}[chunkId] + ".chunk.js";
};